import { useCallback } from 'react';
import {
    CheckoutMapSettingsItem,
    CheckoutMapSettingsItemSettingName,
    CheckoutMapSettingsVo,
} from 'features/settings/components/ppoints/design-settings/CheckoutMapSettings/model/CheckoutMapSettings';

/**
 * Hook to map between CheckoutMapSettingsItem[] and CheckoutMapSettingsVo
 */
export const useCheckoutMapSettingsMapper = () => {
    /**
     * Maps an array of CheckoutMapSettingsItem to CheckoutMapSettingsVo
     */
    const mapToVo = useCallback((items: CheckoutMapSettingsItem[]): CheckoutMapSettingsVo => {
        if (!items || items.length === 0) {
            return {
                google_map_api_key: '',
            };
        }

        const result: CheckoutMapSettingsVo = {
            google_map_api_key: '',
        };

        items.forEach((item) => {
            switch (item.setting_name) {
                case CheckoutMapSettingsItemSettingName.GOOGLE_MAP_API_KEY:
                    result.google_map_api_key = item.value as string;
                    break;
            }
        });

        return result;
    }, []);

    /**
     * Maps CheckoutMapSettingsVo to an array of CheckoutMapSettingsItem
     */
    const mapFromVo = useCallback(
        (vo: CheckoutMapSettingsVo, data: CheckoutMapSettingsItem[]): CheckoutMapSettingsItem[] => {
            if (!vo) {
                return [];
            }

            const dataToSend: CheckoutMapSettingsItem[] = [];

            Object.entries(vo).forEach(([key, value]) => {
                if (value) {
                    dataToSend.push({
                        setting_id: data?.find((item) => item.setting_name === key)?.setting_id,
                        setting_name: key as CheckoutMapSettingsItemSettingName,
                        value: value as string,
                        ecom_id: data?.find((item) => item.setting_name === key)?.ecom_id,
                        ecom_setting_id: data?.find((item) => item.setting_name === key)?.ecom_setting_id,
                    });
                }
            });

            return dataToSend;
        },
        []
    );

    return {
        mapToVo,
        mapFromVo,
    };
};
